import Widget,{fetchInsertWidget} from "./Widget";


export {
  fetchInsertWidget
}

export default Widget;